import { FC } from 'react';
import { validate as uuidValidate } from 'uuid';
import AppsUsage from './steps/AppsUsage';
// import PricingModel from './steps/PricingModel';
import AppType from './steps/AppType';
import AppScope from './steps/AppScope';
import AuthoriseAccounts from './steps/AuthoriseAccounts';
import AppDetails from './steps/AppDetails';
import AppDistribute from './steps/AppDistribute';
import MonthlyFee from './steps/MonthlyFee';
import ServiceApi from './steps/ServiceApi';
import AppPlan from './steps/AppPlan';
// import AppPricingModelType from './steps/AppPricingModelType';
// import { arrayInsertItem } from 'utils';

export interface IFormConfig {
  [key: string]: {
    title: string;
    description: string;
    prevStep?: string;
    buttonText?: string;
    component?: FC<any>;
    isInlineButton?: boolean;
    isFullHeight?: boolean;
    validate?: (values: any) => boolean;
  };
}

type ValidationName = 'roles' | 'environments' | 'nameAndCategories' | 'plan' | 'appDistribute';
// | 'appPricingModelType';

type IValidateinByName = {
  [key in ValidationName]: (values: any) => boolean;
};

const validatingByName: IValidateinByName = {
  roles: ({ roles }) => roles?.length,
  environments: ({ environments }) => environments?.length && uuidValidate(environments),
  nameAndCategories: ({ name, categories }) => {
    const nameLimit = 64;
    const formattedName = name?.trim();
    return formattedName && nameLimit >= formattedName.length && categories?.length;
  },
  // appPricingModelType: ({ payPerUsageEntity }) => {
  //   const entityNameLimit = 20;
  //   const formattedName = payPerUsageEntity?.trim();
  //   return formattedName && entityNameLimit >= formattedName.length;
  // },
  plan: ({ plan }) => plan,
  appDistribute: ({ allowedCountries }) => allowedCountries?.length,
};

export const formConfig: IFormConfig = {
  start: {
    title: 'form.start.title',
    description: 'form.start.description',
    buttonText: 'form.buttonText.start.now',
    isInlineButton: true,
    isFullHeight: true,
  },
  appType: {
    title: 'form.appType.title',
    description: 'form.appType.description',
    component: AppType,
  },
  serviceApi: {
    title: 'form.serviceApi.title',
    description: 'form.serviceApi.description',
    component: ServiceApi,
  },
  appUsage: {
    title: 'form.appUsage.title',
    description: 'form.appUsage.description',
    component: AppsUsage,
  },
  privateAppScope: {
    title: 'form.privateAppScope.title',
    description: 'form.private.appScope.description',
    component: AppScope,
    buttonText: 'form.buttonText.continue',
    validate: validatingByName.roles,
  },
  selectAccount: {
    title: 'form.selectAccount.title',
    description: 'form.selectAccount.description',
    component: AuthoriseAccounts,
    buttonText: 'form.buttonText.continue',
    validate: validatingByName.environments,
  },
  privateAppDetails: {
    title: 'form.privateAppDetails.title',
    description: 'form.privateAppDetails.description',
    component: AppDetails,
    buttonText: 'form.buttonText.create.app',
    validate: validatingByName.nameAndCategories,
  },
  appDistribute: {
    title: 'form.appDistribute.title',
    description: 'form.appDistribute.description',
    component: AppDistribute,
    buttonText: 'form.buttonText.continue',
    validate: validatingByName.appDistribute,
  },
  publicAppScope: {
    title: 'form.publicAppScope.title',
    description: 'form.publicAppScope.description',
    component: AppScope,
    buttonText: 'form.buttonText.continue',
    validate: validatingByName.roles,
  },
  authorizeAccount: {
    title: 'form.authorizeAccount.title',
    description: 'form.authorizeAccount.description',
    component: AuthoriseAccounts,
    buttonText: 'form.buttonText.continue',
    validate: validatingByName.environments,
  },
  // pricingModel: {
  //   title: 'form.pricingModel.title',
  //   description: 'form.pricingModel.description',
  //   component: PricingModel,
  // },
  // appPricingModelType: {
  //   title: 'form.pricingModelType.title',
  //   description: 'form.pricingModelType.description',
  //   component: AppPricingModelType,
  //   buttonText: 'form.buttonText.continue',
  //   validate: validatingByName.appPricingModelType,
  // },
  monthlyFee: {
    title: 'form.monthlyFee.title',
    description: 'form.monthlyFee.description',
    component: MonthlyFee,
    buttonText: 'form.buttonText.continue',
  },
  appPlan: {
    title: 'form.appPlan.title',
    description: 'form.appPlan.description',
    component: AppPlan,
    // buttonText: 'form.buttonText.continue',
    validate: validatingByName.plan,
  },
  publicAppDetail: {
    title: 'form.publicAppDetail.title',
    description: 'form.publicAppDetail.description',
    component: AppDetails,
    buttonText: 'form.buttonText.create.app',
    validate: validatingByName.nameAndCategories,
  },
};

const {
  start,
  appType,
  appUsage,
  appDistribute,
  privateAppScope,
  selectAccount,
  privateAppDetails,
  publicAppDetail,
  publicAppScope,
  authorizeAccount,
  // pricingModel, // disabled since pricing can be modified after app creation
  appPlan,
  // appPricingModelType,
} = formConfig;

export const stepsPrivateApp = [
  start,
  appType,
  appUsage,
  appDistribute, // because of paid apps for private apps
  privateAppScope,
  selectAccount,
  privateAppDetails,
];

export const stepsPublicApp = [
  start,
  appType,
  appUsage,
  appDistribute,
  publicAppScope,
  authorizeAccount,
  // pricingModel,
  appPlan,
  publicAppDetail,
];

// PPU = Pay-per-usage
// export const stepsPublicAppPPU = arrayInsertItem(
// stepsPublicApp,
// stepsPublicApp.length - 2,
// appPricingModelType
// );

// const formPrivateApp = [];
// const formPublicAppFrontEnd = [];
// const formPublicAppFrontEndPaid = [];
// const formPublicAppBackEnd = [];
// const formPrivateAppBackEnd = [];
